import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SwatchSVG = styled.svg.withConfig({
  displayName: "ConditionalFormattingPaletteSquatch__SwatchSVG",
  componentId: "g2udmu-0"
})(({
  theme: _theme
}) => {
  return {
    border: `${_theme.borderWidth['100']} solid ${_theme.color['border-core-default']}`,
    borderRadius: _theme.borderRadius['100']
  };
});
const ConditionalFormattingPaletteSquatch = ({
  minColor,
  midColor,
  maxColor,
  paletteId
}) => {
  return /*#__PURE__*/_jsxs(SwatchSVG, {
    width: 20,
    height: 20,
    viewBox: "0 0 50 50",
    children: [/*#__PURE__*/_jsxs("linearGradient", {
      id: paletteId,
      children: [/*#__PURE__*/_jsx("stop", {
        offset: "0%",
        stopColor: minColor
      }), midColor && /*#__PURE__*/_jsx("stop", {
        offset: "50%",
        stopColor: midColor
      }), /*#__PURE__*/_jsx("stop", {
        offset: "100%",
        stopColor: maxColor
      })]
    }), /*#__PURE__*/_jsx("rect", {
      x: "0",
      y: "0",
      width: "50",
      height: "50",
      rx: "2",
      ry: "2",
      fill: `url(#${paletteId})`
    })]
  });
};
export default ConditionalFormattingPaletteSquatch;